// URL ↔ state for the /documents library's tab filter (ui-spec §10.5).
//
// Canonical values match the schema-source-of-truth nomenclature: `all`,
// `inbox`, `assigned`. The PRD's tab label "Inbox (unassigned)" is a human
// rendering of `inbox` — the URL param and DOM identifiers use the canonical
// short form per the naming-discipline rule in CONTEXT.md.
//
// `all` is the default; we omit it from the URL search string so a fresh
// /documents URL is the canonical "no tab override" shape (ui-spec §7.2).

export type DocumentsTab = 'all' | 'inbox' | 'assigned';

const VALID_TABS: ReadonlySet<DocumentsTab> = new Set(['all', 'inbox', 'assigned']);

export function parseDocumentsTab(input: unknown): DocumentsTab {
  if (typeof input !== 'string') return 'all';
  return VALID_TABS.has(input as DocumentsTab) ? (input as DocumentsTab) : 'all';
}

export function documentsTabToSearch(tab: DocumentsTab): { tab?: DocumentsTab } {
  return tab === 'all' ? {} : { tab };
}
